import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';
import useAuthStore from '../../store/authStore';
import toast from 'react-hot-toast';

export default function DoctorProfile() {
  const { user, updateUser } = useAuthStore();
  const [form, setForm] = useState({
    bio:'', clinic_name:'', clinic_address:'',
    consultation_fee:0, home_visit_available:false,
    home_visit_fee:0, teleconsultation_available:false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/auth/me').then(res => {
      const doc = res.data.doctor;
      if (doc) setForm({
        bio: doc.bio || '',
        clinic_name: doc.clinic_name || '',
        clinic_address: doc.clinic_address || '',
        consultation_fee: doc.consultation_fee || 0,
        home_visit_available: doc.home_visit_available || false,
        home_visit_fee: doc.home_visit_fee || 0,
        teleconsultation_available: doc.teleconsultation_available || false,
      });
    });
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.put('/doctor/profile', form);
      toast.success('Profil mis à jour !');
    } catch(e) { toast.error('Erreur'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b px-4 py-3 flex items-center gap-3 sticky top-0 z-10">
        <Link to="/doctor/dashboard" className="text-green-600 font-medium">← Retour</Link>
        <h1 className="font-bold text-gray-800">Mon profil médecin</h1>
      </div>

      <div className="max-w-lg mx-auto p-4 space-y-4">
        {/* Infos non modifiables */}
        <div className="card bg-green-50 border-green-200">
          <p className="font-bold text-green-800">{user?.name}</p>
          <p className="text-sm text-green-600">📱 {user?.phone}</p>
          <p className="text-xs text-green-500 mt-1">
            {user?.is_verified ? '✅ Compte vérifié' : '⏳ En attente de vérification'}
          </p>
        </div>

        <form onSubmit={save} className="space-y-4">
          <div className="card space-y-3">
            <h3 className="font-bold text-gray-800">🏥 Cabinet</h3>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">Nom du cabinet</label>
              <input className="input-field" placeholder="Ex: Clinique du Bénin" value={form.clinic_name}
                onChange={e => setForm({...form, clinic_name: e.target.value})} />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">Adresse</label>
              <input className="input-field" placeholder="Ex: Quartier Adidogomé, Lomé" value={form.clinic_address}
                onChange={e => setForm({...form, clinic_address: e.target.value})} />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">Tarif consultation (FCFA)</label>
              <input className="input-field" type="number" value={form.consultation_fee}
                onChange={e => setForm({...form, consultation_fee: e.target.value})} />
            </div>
          </div>

          <div className="card space-y-3">
            <h3 className="font-bold text-gray-800">📝 Biographie</h3>
            <textarea className="input-field resize-none" rows={4}
              placeholder="Décrivez votre parcours, spécialisations..."
              value={form.bio} onChange={e => setForm({...form, bio: e.target.value})} />
          </div>

          <div className="card space-y-3">
            <h3 className="font-bold text-gray-800">⚙️ Services proposés</h3>
            {[
              ['teleconsultation_available', '📹 Téléconsultation vidéo'],
              ['home_visit_available', '🏠 Visite à domicile'],
            ].map(([key, label]) => (
              <div key={key} className="flex items-center justify-between">
                <span className="text-sm text-gray-700">{label}</span>
                <button type="button" onClick={() => setForm(f => ({...f, [key]: !f[key]}))}
                  className={`w-12 h-6 rounded-full transition-all ${form[key] ? 'bg-green-500' : 'bg-gray-300'}`}>
                  <div className={`w-5 h-5 bg-white rounded-full shadow transition-all mx-0.5 ${form[key] ? 'translate-x-6' : 'translate-x-0'}`} />
                </button>
              </div>
            ))}
            {form.home_visit_available && (
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Tarif visite domicile (FCFA)</label>
                <input className="input-field" type="number" value={form.home_visit_fee}
                  onChange={e => setForm({...form, home_visit_fee: e.target.value})} />
              </div>
            )}
          </div>

          <button type="submit" disabled={loading} className="btn-primary w-full py-3">
            {loading ? 'Enregistrement...' : '💾 Sauvegarder'}
          </button>
        </form>
      </div>
    </div>
  );
}
